import { AuthProvider } from '@/contexts/AuthProvider';
import { TooltipProvider } from './components/ui/tooltip';
import { Toaster } from './components/ui/toaster';
import { QueryClientProvider } from '@tanstack/react-query';
import { Outlet } from 'react-router-dom';
import { MeshFilesProvider } from '@/contexts/MeshFilesContext';
import { CartProvider } from '@/contexts/cart/CartProvider';
import { createQueryClient } from '@/lib/queryClient';
import { AnonZeroHarnessBadge } from '@/components/dev/AnonZeroHarnessBadge';

const queryClient = createQueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <MeshFilesProvider>
          {/* Marketplace cart — app-wide so the menu-bar badge and every
              /market surface share one cart. Catalog-free (ids only), so it
              adds nothing to the always-loaded bundle. */}
          <CartProvider>
            <TooltipProvider delayDuration={1000} skipDelayDuration={0}>
              <Toaster />
              <div className="relative flex min-h-screen flex-col">
                <Outlet />
              </div>
              {import.meta.env.DEV && <AnonZeroHarnessBadge />}
            </TooltipProvider>
          </CartProvider>
        </MeshFilesProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
